import React from "react";
import { Drawer, Alert } from "gold-ui-kit";
import { BookOpen, ChevronRight } from "lucide-react";
import { getDoc } from "../../data/pageDocs";

const renderInline = (text) => {
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((p, i) =>
    p.startsWith("**") && p.endsWith("**") ? (
      <strong key={i} className="font-bold text-slate-900">{p.slice(2, -2)}</strong>
    ) : (
      <span key={i}>{p}</span>
    )
  );
};

const HelpPanel = ({ pageId, isOpen, onClose }) => {
  const doc = getDoc(pageId);

  return (
    <Drawer
      isOpen={isOpen}
      onClose={onClose}
      position="right"
      size={95}
      variant="blur"
      className="!w-[460px] !max-w-[95vw]"
      title={
        <span className="flex items-center gap-3">
          <span className="w-9 h-9 rounded-xl bg-amber-50 border border-amber-200 flex items-center justify-center text-amber-600">
            <BookOpen size={18} />
          </span>
          <span className="leading-tight">
            <span className="block text-[10px] font-bold uppercase tracking-wider text-slate-400">
              Dokümantasyon & Rehber
            </span>
            <span className="block text-sm font-bold text-slate-900">{doc?.title || "Sayfa Yardımı"}</span>
          </span>
        </span>
      }
      footer={
        <span className="w-full text-[11px] text-slate-500">
          Üst bardaki <strong>Yardım</strong> butonundan dokümantasyona istediğiniz zaman ulaşabilirsiniz.
        </span>
      }
    >
      <div data-testid="help-panel" className="text-xs leading-relaxed text-slate-600 space-y-6">
        {!doc ? (
          <div className="text-slate-400 text-center py-10">Bu sayfa için dokümantasyon henüz yazılmamış.</div>
        ) : (
          <>
            <Alert color="primary" variant="filled" size="sm" title="Sayfa Amacı" description={doc.purpose} />

            {doc.sections.map((sec, i) => (
              <div key={i} className="space-y-2.5">
                <h4 className="text-xs font-bold text-slate-900 flex items-center gap-2 border-b border-slate-100 pb-1.5">
                  <span className="w-1.5 h-3.5 bg-amber-500 rounded-full" />
                  {sec.heading}
                </h4>
                <ul className="space-y-2 pl-2">
                  {sec.items.map((it, j) => (
                    <li key={j} className="flex items-start gap-2">
                      <ChevronRight size={14} className="text-amber-500 shrink-0 mt-0.5" />
                      <span>{renderInline(it)}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </>
        )}
      </div>
    </Drawer>
  );
};

export default HelpPanel;
